import React from "react";
import { teamMembers } from "../assets/data/Data";

const About = () => {
  return (
    <section className="pb-12">
      <div className="dark:bg-primary-darkBgOther bg-[#d0eff5] pt-20 pb-8 px-4">
        <div className="max-w-3xl mx-auto lg:text-center space-y-4">
          <h4>
            We are a team who loves supporting the community through events
          </h4>
          <p>
            Our aim is to provide a powerful and affordable event ticketing
            solution that can handle events of any size and complexity without
            an issue.
          </p>
        </div>
      </div>

      <div className="w-full max-w-7xl mx-auto px-6 lg:px-8 py-10">
        <div className="text-center mb-12 space-y-4">
          <h4>The Team Behind GOOD VIBZ</h4>
          <p>
            Every day we are passionately dedicated to making buying and selling
            tickets simple and secure.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="dark:bg-primary-darkBg bg-white border dark:border-none rounded px-2 pt-2 pb-6 text-center"
            >
              <img
                src={member.image}
                alt={member.name}
                className="h-52 rounded-md object-cover mb-4"
              />
              <h4>{member.name}</h4>
              <p className="mb-2 pt-2">{member.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
